import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { TreeViewAutocomplete } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TreeViewAutocomplete_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TreeViewAutocomplete_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const TreeViewAutocomplete_TreeViewAutocomplete = (t0)=>{
    const $ = c(37);
    const { disabled, name, label, labelIcon, tooltip, options, placeholder, clearable, loading, required, getOptionLabel, noOptionsText, validate: t1, onChange, onChildrenLoad, onSearch, onLoadTree, testId, renderSearchOption, renderOption, withoutMargins } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = void 0 === t1 ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const validate = t2;
    let t3;
    if ($[2] !== validate) {
        t3 = Array.isArray(validate) ? validate : [
            validate
        ];
        $[2] = validate;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = compose(t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4) {
        t5 = {
            validate: t4
        };
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const { input, meta } = useField(name, t5);
    let t6;
    if ($[8] !== input || $[9] !== onChange) {
        t6 = (value, item)=>{
            input.onChange(value);
            if (onChange) onChange(value, item);
        };
        $[8] = input;
        $[9] = onChange;
        $[10] = t6;
    } else t6 = $[10];
    const handleChange = t6;
    let t7;
    if ($[11] !== input) {
        t7 = ()=>{
            input.onBlur();
        };
        $[11] = input;
        $[12] = t7;
    } else t7 = $[12];
    const handleBlur = t7;
    const t8 = meta.touched && !!meta.error;
    const t9 = meta.touched && meta.error;
    let t10;
    if ($[13] !== clearable || $[14] !== disabled || $[15] !== getOptionLabel || $[16] !== handleBlur || $[17] !== handleChange || $[18] !== input || $[19] !== label || $[20] !== labelIcon || $[21] !== loading || $[22] !== noOptionsText || $[23] !== onChildrenLoad || $[24] !== onLoadTree || $[25] !== onSearch || $[26] !== options || $[27] !== placeholder || $[28] !== renderOption || $[29] !== renderSearchOption || $[30] !== required || $[31] !== t8 || $[32] !== t9 || $[33] !== testId || $[34] !== tooltip || $[35] !== withoutMargins) {
        t10 = /*#__PURE__*/ jsx(TreeViewAutocomplete, _object_spread_props(_object_spread({}, input), {
            value: input.value,
            testId: testId,
            onChange: handleChange,
            onBlur: handleBlur,
            label: label,
            labelIcon: labelIcon,
            options: options,
            disabled: disabled,
            tooltip: tooltip,
            placeholder: placeholder,
            clearable: clearable,
            loading: loading,
            required: required,
            getOptionLabel: getOptionLabel,
            noOptionsText: noOptionsText,
            error: t8,
            helperText: t9,
            onChildrenLoad: onChildrenLoad,
            onSearch: onSearch,
            onLoadTree: onLoadTree,
            renderSearchOption: renderSearchOption,
            renderOption: renderOption,
            withoutMargins: withoutMargins
        }));
        $[13] = clearable;
        $[14] = disabled;
        $[15] = getOptionLabel;
        $[16] = handleBlur;
        $[17] = handleChange;
        $[18] = input;
        $[19] = label;
        $[20] = labelIcon;
        $[21] = loading;
        $[22] = noOptionsText;
        $[23] = onChildrenLoad;
        $[24] = onLoadTree;
        $[25] = onSearch;
        $[26] = options;
        $[27] = placeholder;
        $[28] = renderOption;
        $[29] = renderSearchOption;
        $[30] = required;
        $[31] = t8;
        $[32] = t9;
        $[33] = testId;
        $[34] = tooltip;
        $[35] = withoutMargins;
        $[36] = t10;
    } else t10 = $[36];
    return t10;
};
export { TreeViewAutocomplete_TreeViewAutocomplete as TreeViewAutocomplete };
